import { Box, Skeleton } from "@mui/material";
import React from "react";

export const JobRowSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        width: "100%",
        borderBottom: "0.8px solid #ccc",
        padding: "16px 0px",
        minHeight: "90.5px",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      {/* Job Name */}
      <Box sx={{
        width: "20%",
        paddingLeft: "14px",
        minHeight: "58px",
      }}>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingTop: "18px",
        }}>
          <Skeleton width="60%" height={24} />
        </Box>
      </Box>

      {/* Demand */}
      <Box sx={{
        width: "10%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "58px",
      }}>
        <Skeleton width={24} height={24} />
      </Box>

      {/* Value */}
      <Box sx={{
        width: "15%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        height: "58px",
        gap: "8px",
      }}>
        <Skeleton variant="circular" height={24} width={24} />
        <Skeleton variant="text" height={20} width={80} />
      </Box>

      {/* Worker avatars or tags */}
      <Box sx={{
        width: "35%",
        paddingRight: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "8px",
      }}>
        {[...Array(2)].map((_, idx) => (
          <Skeleton key={idx} variant="rectangular" width={320} height={58} sx={{
            borderRadius: "4px",
            border: "1px transparent",
          }} />
        ))}
      </Box>

      {/* Status tags */}
      <Box sx={{
        width: "20%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "8px",
      }}>
        {[...Array(2)].map((_, idx) => (
          <Skeleton key={idx} variant="rectangular" width={100} height={25} sx={{ borderRadius: "12px", marginTop: "16px", marginBottom: "16px" }} />
        ))}
      </Box>
    </Box>
  );
};
